import React, { useEffect, useState } from 'react'
import noop from 'lodash/noop'

import Dropdown from 'src/comps/Atom/Drowpdown'
import PaxesPill from './PaxesPill'
import { PaxesWrapper } from './styles'
import PaxesText from 'src/comps/Atom/PaxesText'
import PaxesSelector from './PaxesSelector'
import { getPaxes } from './helpers'
import { type Room, SearchMode } from 'src/types/search'
import { usePage } from 'src/hooks/usePage'
import { documentBodyFreeze, documentBodyUnfreeze } from 'client/utils'
import { useDevice } from 'src/hooks/useDevice'
import { BreakpointSizes } from 'src/types/device'

interface IPaxesProps {
  initialValue: Room[]
  onChange: (value: Room[]) => void
  mode?: SearchMode
  disabled?: boolean
}

const Paxes = ({
  initialValue,
  onChange = noop,
  mode = SearchMode.Full,
  disabled,
}: IPaxesProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [rooms, setRooms] = useState(initialValue)
  const [isValidationOn, setIsValidationOn] = useState(false)
  const { pageId } = usePage()
  const { activeBreakpoint } = useDevice()
  const isDesktop = activeBreakpoint >= BreakpointSizes.L

  const paxesPlain = getPaxes(initialValue)

  useEffect(() => {
    setRooms(initialValue)
  }, [initialValue])

  useEffect(() => {
    if (pageId !== 'home') return
    if (isDesktop) return

    if (isOpen) documentBodyFreeze()
    else documentBodyUnfreeze()
  }, [isOpen, pageId])

  if (mode === SearchMode.Readonly) {
    return <PaxesText paxes={paxesPlain} mode={mode} />
  }

  const handleChange = (newRooms: Room[]) => {
    setRooms(newRooms)
    setIsValidationOn(false)
  }

  const handleSave = () => {
    onChange(rooms)
  }

  const isChildrenInputInvalid = () => {
    return rooms.some(room => room.children.some(child => child === null))
  }

  const changeDropdownState = (open: boolean) => {
    setIsValidationOn(true)
    if (isChildrenInputInvalid()) return
    setIsOpen(open)
    if (!open) {
      handleSave()
    }
  }

  const handleSavePaxesSelector = () => {
    setIsValidationOn(true)
    if (isChildrenInputInvalid()) return

    handleSave()
    setIsValidationOn(false)
    setIsOpen(false)
  }

  if (disabled) {
    return <PaxesPill mode={mode} paxes={paxesPlain} />
  }

  return (
    <PaxesWrapper mode={mode} className="paxes-wrapper">
      <Dropdown
        onShowChange={changeDropdownState}
        show={isOpen}
        showClose={false}
        trigger={<PaxesPill mode={mode} paxes={paxesPlain} />}
      >
        <PaxesSelector
          rooms={rooms}
          isValidationOn={isValidationOn}
          onChange={handleChange}
          onClose={() => setIsOpen(false)}
          handleSave={handleSavePaxesSelector}
          mode={mode}
        />
      </Dropdown>
    </PaxesWrapper>
  )
}

export default Paxes
